// src/hooks/useClipboardCut.ts
import { useEffect } from 'react';
import { Line, TextNote, ImageElement } from '../components/Canvas/types';

export const useClipboardCut = (
  selection: string[],
  drawingState: { lines: Line[]; textNotes?: TextNote[]; images?: ImageElement[] },
  onUpdateLines: (lines: Line[], textNotes: TextNote[], images: ImageElement[]) => void
) => {
  useEffect(() => {
    const handleCut = (e: Event) => {
      const evt = e as ClipboardEvent;
      if (selection.length === 0) return;
      
      // 1. Сначала получаем выделенные элементы
      const selectedLines = drawingState.lines.filter(l => selection.includes(l.id));
      const selectedTexts = (drawingState.textNotes || []).filter(n => selection.includes(n.id));
      const selectedImages = (drawingState.images || []).filter(i => selection.includes(i.id));
      
      // 2. Копируем выделенные элементы в буфер обмена
      const payload = JSON.stringify({ 
        lines: selectedLines, 
        textNotes: selectedTexts, 
        images: selectedImages 
      });
      evt.clipboardData?.setData('text/plain', payload);
      
      // 3. Удаляем выделенные элементы
      const newTextNotes = (drawingState.textNotes || []).filter(n => !selection.includes(n.id));
      const newLines = drawingState.lines.filter(l => !selection.includes(l.id));
      const newImages = (drawingState.images || []).filter(i => !selection.includes(i.id));
      onUpdateLines(newLines, newTextNotes, newImages);
      
      evt.preventDefault();
    };
    
    const handleKeyDown = (e: KeyboardEvent) => {
      // Проверяем комбинацию Ctrl+X или Cmd+X (для Mac)
      if ((e.ctrlKey || e.metaKey) && e.key === 'x' && !e.shiftKey && !e.altKey) {
        if (selection.length > 0) {
          e.preventDefault();
          handleCut(e);
        }
      }
    };
    
    document.addEventListener('cut', handleCut);
    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('cut', handleCut);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [selection, drawingState, onUpdateLines]);
};